<template>
  <div class="container">
    <div class="header-top">
      <div class="back" @click="back(false)">
        <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
        <span>{{ $t('courses.shareToPortalComponent.back') }}</span>
      </div>
      <div class="operation" v-if="currentType === 'audit'">
        <a-button
          type="primary"
          @click="submitAudit"
          v-if="reviewStatus === '3' || reviewStatus === '0' || reviewStatus === '1' || (reviewStatus === '4' &&isSave === '2')"
          style="margin-right: 10px;"
          :disabled="!id"
        >{{ reviewStatus === '3' ? $t('courses.shareToPortalComponent.resubmit') : $t('courses.shareToPortalComponent.submitAudit') }}</a-button
        >
        <a-button v-if="reviewStatus !== '0' && reviewStatus !== '1'" class="status_btn" @click="reviewStatus === '3' ? (visible = true) : ''">
          <span :class="[reviewStatus === '3' ? 'status' : '']">
            {{
              reviewStatus === '1'
                ? $t('courses.shareToPortalComponent.draft')
                : reviewStatus === '2'
                ? $t('courses.shareToPortalComponent.auditing')
                : reviewStatus === '3'
                ? $t('courses.shareToPortalComponent.auditFailed')
                : reviewStatus === '4'
                ? $t('courses.shareToPortalComponent.auditPassed')
                : '-'
            }}
          </span>
          <span :class="[reviewStatus === '3' ? 'view' : '']" v-if="reviewStatus === '3'">
            {{ $t('courses.shareToPortalComponent.viewReason') }}
          </span>
        </a-button>
      </div>
    </div>
    <div class="tabs">
      <a-button 
        type="primary" 
        :class="[currentType === 'audit' ? 'active' : 'default']" 
        @click="changeType('audit')"
      >{{ $t('courses.shareToPortalComponent.courseAudit') }}</a-button
      >
      <a-button 
        type="primary" 
        :disabled="reviewStatus !== '4'" 
        :class="[currentType === 'set' ? 'active' : 'default']" 
        @click="changeType('set')"
      >{{ $t('courses.shareToPortalComponent.courseSettings') }}</a-button
      >
    </div>
    <a-form :form="form" v-if="currentType === 'audit'">
      <div class="content">
        <div class="list">
          <a-form-item :label="$t('courses.shareToPortalComponent.courseName')" :colon="false">
            <a-input
              v-decorator="['lessonName', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseName') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseSelectCourseName')"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            >
            </a-input>
          </a-form-item>
          <!-- <a-form-item :label="'课程负责人'" :colon="false">
            <a-select
              v-decorator="['classId', { rules: [{ required: true, message: '请选择课程负责人' }] }]"
              placeholder="请选择课程负责人"
              allowClear
            >
              <a-select-option v-for="item in classOptions" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item> -->
          <a-form-item :label="$t('courses.shareToPortalComponent.teachingTeam')" :colon="false">
            <a-select
              mode="multiple"
              v-decorator="['teachingTeam', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseSelectTeachingTeam') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseSelectTeachingTeam')"
              allowClear
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            >
              <a-select-option v-for="item in teacherList" :key="item.id" :value="item.id.toString()">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('courses.shareToPortalComponent.courseMajorCategory')" :colon="false">
            <a-cascader
              :options="majorTreeList"
              :placeholder="$t('courses.shareToPortalComponent.pleaseSelectCourseMajorCategory')"
              v-decorator="['lessonMajor', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseMajorCategory') }] }]"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            />
          </a-form-item>
          <a-form-item :label="$t('courses.shareToPortalComponent.courseLanguage')" :colon="false">
            <a-input
              v-decorator="['lessonLanguage', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseLanguage') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCourseLanguage')"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            >
            </a-input>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('courses.shareToPortalComponent.courseHours')" :colon="false">
            <a-input
              type="number"
              v-decorator="['lessonHours', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseHours') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCourseHours')"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            >
            </a-input>
          </a-form-item>
          <a-form-item :label="$t('courses.shareToPortalComponent.courseCredits')" :colon="false">
            <a-input
              type="number"
              v-decorator="['lessonCredit', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseCredits') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCourseCredits')"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            >
            </a-input>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('courses.shareToPortalComponent.courseIntroduction')" :colon="false">
            <a-textarea
              v-decorator="['lessonIntro', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseIntroduction') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCourseIntroduction')"
              maxLength="500"
              :auto-size="{ minRows: 2, maxRows: 6 }"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            />
          </a-form-item>
          <a-form-item :label="$t('courses.shareToPortalComponent.courseObjective')" :colon="false">
            <a-textarea
              v-decorator="['lessonGoal', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseObjective') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCourseObjective')"
              maxLength="500"
              :auto-size="{ minRows: 2, maxRows: 6 }"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            />
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('courses.shareToPortalComponent.coursePlan')" :colon="false">
            <a-textarea
              v-decorator="['lessonPlan', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCoursePlan') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCoursePlan')"
              maxLength="500"
              :auto-size="{ minRows: 2, maxRows: 6 }"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            />
          </a-form-item>
          <a-form-item :label="$t('courses.shareToPortalComponent.courseDifficulties')" :colon="false">
            <a-textarea
              v-decorator="['lessonDifficulty', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseDifficulties') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCourseDifficulties')"
              maxLength="500"
              :auto-size="{ minRows: 2, maxRows: 6 }"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            />
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('courses.shareToPortalComponent.courseTextbook')" :colon="false">
            <a-input
              v-decorator="['lessonMaterial', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseTextbook') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCourseTextbook')"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            >
            </a-input>
          </a-form-item>
          <a-form-item :label="$t('courses.shareToPortalComponent.courseAttribute')" :colon="false">
            <a-input
              v-decorator="['lessonAttribute', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseInputCourseAttribute') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseInputCourseAttribute')"
              :disabled="currentType === 'audit' && (reviewStatus === '2')"
            >
            </a-input>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('courses.shareToPortalComponent.courseCoverImage')" :colon="false">
            <div style="width: 300px; height: 160px;">
              <Upload
                @uploadData="photosUploadOk"
                :fileUrl="form.getFieldValue('lessonCover')"
                :accept="['png', 'jpg']"
                :desc="['', $t('courses.shareToPortalComponent.onlySupportFormat')]"
                v-decorator="['lessonCover', {}]"
              />
            </div>
          </a-form-item>
        </div>
      </div>
    </a-form>
    <a-form :form="form" v-else>
      <div class="content">
        <div class="list">
          <a-form-item :label="$t('courses.shareToPortalComponent.courseStatus')" :colon="false">
            <a-select
              v-decorator="['archiveStatus', { rules: [{ required: true, message: $t('courses.shareToPortalComponent.pleaseSelectCourseStatus') }] }]"
              :placeholder="$t('courses.shareToPortalComponent.pleaseSelectCourseStatus')"
            >
              <a-select-option value="1">
                {{ $t('courses.shareToPortalComponent.unarchive') }}
              </a-select-option>
              <a-select-option value="2">
                {{ $t('courses.shareToPortalComponent.archive') }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </div>
    </a-form>
    <div class="list-button">
      <a-button
        type="primary"
        @click="save"
        :disabled="currentType === 'audit' && (reviewStatus === '2')"
        >{{ $t('courses.shareToPortalComponent.save') }}</a-button
      >
    </div>
    <a-modal v-model="visible" :title="$t('courses.shareToPortalComponent.failedReason')" :footer="null">
      <p>{{ reviewNotes }}</p>
    </a-modal>
  </div>
</template>
<script>
import TipModal from '@/components/tipModal/index.vue'
import { shareLessonSave, getAllTeacher, lessonSubmitAudit } from '@/api/lesson'
import { courseReviewDetail, courseSet, getCourseSetting } from '@/api/admin'
import Upload from '@/components/upload/index.vue'

export default {
  components: {
    TipModal,
    Upload
  },
  data() {
    return {
      id: undefined,
      form: this.$form.createForm(this),
      teacherList: [],
      majorTreeList: [],
      currentType: 'audit',
      reviewNotes: '',
      visible: false,
      reviewStatus: '', // 审核状态 1-草稿 2-审核中 3-审核驳回 4-审核通过
      isSave: '1' // 1 未提交 2 已提交
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'myCourses'
      })
    },
    photosUploadOk(data) {
      this.form.setFieldsValue({
        lessonCover: data[0] ? data[0].url : ''
      })
    },
    getMajorData() {
      this.majorTreeList = JSON.parse(localStorage.treeList)
      this.majorTreeList.forEach(item => {
        item.children.forEach(child => {
          child.children = child.sub
        })
      })
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 表单校验通过，调用保存接口
          const data = Object.assign(values, {
            id: this.id,
            lessonId: this.$route.query.lessonId
          })
          if (values.lessonMajor && values.lessonMajor.length === 3) {
            data.categoryV1 = values.lessonMajor[0].toString()
            data.categoryV2 = values.lessonMajor[1].toString()
            data.categoryV3 = values.lessonMajor[2].toString()
          }
          if (!data.id) {
            delete data.id
          }
          if (this.currentType === 'audit') {
            shareLessonSave(data).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('courses.shareToPortalComponent.saveSuccess'))
                this.getCourseReviewDetail()
              }
            })
          } else {
            courseSet(data).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('courses.shareToPortalComponent.saveSuccess'))
                this.getCourseSettingDeatil()
              }
            })
          }
        }
      })
    },
    getCourseReviewDetail() {
      courseReviewDetail({ lessonId: this.$route.query.lessonId }).then(res => {
        if (res.code === 200) {
          const data = res.data
          this.form.setFieldsValue({
            lessonName: data.lessonName,
            lessonMajor: data.categoryV1 ? [Number(data.categoryV1), Number(data.categoryV2), data.categoryV3] : undefined,
            lessonLanguage: data.lessonLanguage,
            guidanceType: data.guidanceType,
            lessonHours: data.lessonHours,
            lessonIntro: data.lessonIntro,
            lessonGoal: data.lessonGoal,
            lessonPlan: data.lessonPlan,
            lessonDifficulty: data.lessonDifficulty,
            lessonMaterial: data.lessonMaterial,
            lessonAttribute: data.lessonAttribute,
            lessonCover: data.lessonCover,
            teachingTeam: data.teachingTeam,
            lessonCredit: data.lessonCredit
          })
          this.id = data.id !== '0' ? data.id : ''
          this.reviewStatus = data.reviewStatus
          this.reviewNotes = data.reviewNotes
          this.isSave = data.isSave
        }
      })
    },
    getCourseSettingDeatil() {
      getCourseSetting({
        lessonId: this.$route.query.lessonId
      }).then(res => {
        if (res.code === 200) {
          this.form.setFieldsValue({
            archiveStatus: res.data.archiveStatus
          })
        }
      })
    },
    submitAudit() {
      lessonSubmitAudit({ id: this.id }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('courses.shareToPortalComponent.submitSuccess'))
          this.getCourseReviewDetail()
        }
      })
    },
    changeType(type) {
      this.currentType = type
      this.form.resetFields()

      if (type === 'audit') {
        this.getCourseReviewDetail()
      } else {
        this.getCourseSettingDeatil()
      }
    }
  },
  mounted() {
    getAllTeacher({}).then(res => {
      if (res.code == 200) {
        this.teacherList = res.data.list
      }
    })
    this.getMajorData()
    this.getCourseReviewDetail()
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 18px 21px;
}
.header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .operation {
    display: flex;
    align-items: center;

    .status_btn {
      min-width: 100px;
      height: 35px;
      line-height: 35px;
    }
    .status {
      display: block;
    }
    .view {
      display: none;
    }
    &:hover {
      .status {
        display: none;
      }
      .view {
        display: block;
      }
    }
  }
}
.header {
  margin-bottom: 22px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ededed;
  .title {
    font-size: 16px;
    font-weight: 800;
    color: #000000;
  }
}
.content {
  height: calc(100% - 33px);
  overflow-y: auto;
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.button {
  cursor: pointer;
}
.ant-form {
  position: relative;
  height: calc(100% - 155px);
  .list {
    display: flex;
    margin-bottom: 12px;
    .ant-form-item-label {
      font-size: 14px;
      color: #000;
      line-height: 20px;
    }
    .ant-form-item {
      width: calc((100% - 140px) / 2);
      margin-bottom: 0;
      margin-right: 70px;
    }
    /deep/.select-button.ant-btn.disabled {
      color: #a2a2a2 !important;
      background: none;
    }
    /deep/.ant-input,
    /deep/.select-button.ant-btn,
    /deep/.ant-input-affix-wrapper {
      width: 100%;
      height: 35px;
      color: #000000 !important;
      margin-right: 11px;
    }
    /deep/.ant-select-selection__rendered {
      .ant-select-selection-selected-value {
        color: #000;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input .ant-input {
        width: 100%;
        height: 35px;
        margin-right: 0;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .select-button,
    .ant-calendar-picker {
      width: 100%;
      height: 35px;
      color: #000000;
      line-height: 35px;
    }
    .select-button {
      padding: 0 20px;
      text-align: left;
      color: #a2a2a2;
      position: relative;
      img {
        top: 14px;
        width: 11px;
        right: 20px;
        position: absolute;
      }
    }
  }
}
.list-button {
  display: flex;
  justify-content: center;
}
/deep/.ant-modal {
  .ant-modal-title {
    font-size: 16px;
    font-weight: 550;
  }
  .total {
    color: #687f9c;
    margin: 12px 0;
  }
  .ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    margin-bottom: 22px;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 0;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      height: 35px;
      .ant-input {
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-color: #d8dce0;
        box-shadow: none;
      }
    }
    .ant-input-group-addon .search-btn {
      border-left: 0;
      height: 35px;
      border-color: #d8dce0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      span {
        display: flex;
        font-size: 14px;
        color: #333333;
        position: relative;
        align-items: center;
        &::before {
          left: -8px;
          content: '';
          width: 1px;
          height: 15px;
          background: #e9e9e9;
          position: absolute;
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
  .ant-modal-body {
    position: relative;
    .ant-table-wrapper {
      margin-bottom: 60px;
      .prepare-name {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
        display: inline-block;
      }
      .button {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #5b7499;
        line-height: 20px;
        margin-right: 10px;
      }
    }
    .list-pagination {
      width: calc(100% - 48px);
      bottom: 80px;
      position: absolute;
      .pagination {
        padding: 25px 0;
      }
    }
  }
}

// 表格样式
.l-table {
  width: 100%;
  .l-table-header {
    display: flex;
    background-color: #edf2f6;
    color: #6b738c;
    .l-table-head-cell {
      width: 100px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .l-table-body {
    .l-table-row {
      display: flex;
      border-bottom: 1px solid #e9e9e9;
      .l-table-cell-left {
        width: 200px;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #000;
        text-align: center;
        border: solid 1px #e9e9e9;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: none;
        border-top: none;
        flex-direction: column;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        padding: 0 10px;
        position: relative;
        .remove {
          height: 13px;
          width: 13px;
          margin-top: -18px;
          position: absolute;
          right: 5px;
          top: 5px;
          cursor: pointer;
          display: none;
        }
        &:hover {
          background-color: #f6f6f6;
          .remove {
            display: block;
          }
        }
      }
      &:last-child {
        border-bottom: none;
      }
      .l-table-cell {
        flex: 1;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #000;
        .l-table-cell-row {
          display: flex;
          text-align: center;
          width: 100%;
          .l-table-cell-cell {
            height: 45px;
            line-height: 45px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #000;
            border: 1px solid #e9e9e9;
            border-top: none;
          }
        }
      }
    }
  }
  /deep/ .ant-select-selection-selected-value,
  .ant-select-selection__placeholder {
    width: 100%;
  }
  /deep/ .ant-select-selection__rendered {
    text-align: center;
  }
}
/deep/ .ant-btn-primary[disabled] {
  color: rgba(0, 0, 0, 0.25) !important;
  background: #f5f5f5 !important;
  border-color: #d9d9d9;
}
.tabs {
  margin-bottom: 20px;
  background-color: #edf3fa;
  width: 260px;
  border-radius: 30px;
  .active {
    box-shadow: none;
    width: 130px;
    color: #fff !important;
    background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%) !important;
  }
  /deep/ .ant-btn {
    border-radius: 20px !important;
    &:hover {
      background: #edf3fa;
      color: #6b738c !important;
    }
  }
}
.default {
  box-shadow: none;
  width: 130px;
  background: #edf3fa;
  color: #6b738c !important;
}
</style>
